import request from '../../axios';
import {IPatchBasketPayload} from './usePatchBasket';

export const patchBasket = async (payload: IPatchBasketPayload) => {
  const {data}: {data: IResponse} = await request.patch(
    `/api/v2/order/basket/${payload.basket_guid}`,
    payload,
  );
  return data;
};
